<template>
  <custom-dialog width="500px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <!-- 用户信息 -->
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('fms_body_recipientItem_dialog.suo_shu_gong_si')" prop="partnerOrgId" :rules="rules.partnerOrgId">
              <custom-select
                v-model="form.partnerOrgId"
                url="partnerSelectPartnerLimit"
                :listener="`${form.partnerOrgId}`"
                filterable
                remote
                :props="{label:'partnerNameCode',value:'partnerOrgId'}"
                :params="{num:50,partnerOrgId:form.partnerOrgId,orgTypeList:['CS','JV','JV_SC']}"
                :clearable="false"
                width="100%"
              ></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('fms_body_recipientItem_dialog.na_shui_deng_ji_hao')" prop="buyerNumber">
              <el-input
                v-model="form.buyerNumber"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('fms_body_recipientItem_dialog.qi_ye_ming_cheng')" prop="buyerName">
              <el-input
                v-model="form.buyerName"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('fms_body_recipientItem_dialog.dian_hua_hao_ma')" prop="buyerMobile">
              <el-input
                v-model="form.buyerMobile"
                placeholder=""
               ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('fms_body_recipientItem_dialog.yin_hang_zhang_hao')" prop="buyerDepositNumber">
              <el-input
                v-model="form.buyerDepositNumber"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('fms_body_recipientItem_dialog.zhi_hang_ming_cheng')" prop="buyerDepositBank">
              <el-input
                v-model="form.buyerDepositBank"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('fms_body_recipientItem_dialog.ying_ye_di_zhi')" prop="buyerRegisterAddress">
              <el-input
                v-model="form.buyerRegisterAddress"
                type="textarea"
                :rows="2"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('fms_body_recipientItem_dialog.you_xiang')" prop="buyerEmail">
              <el-input
                v-model.trim="form.buyerEmail"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{$t('Common.com_cancel')}}</el-button>
      <el-button type="primary" @click="saveGroup">{{$t('Common.com_confirm')}}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],

  data() {
    return {
      form: {
        buyerDepositBank: '', // 买方银行卡开户支行
        buyerDepositNumber: '', // 买方银行账号
        buyerMobile: '', // 买方电话号码
        buyerName: '', // 买方名称（发票抬头）
        buyerNumber: '', // 买方纳税人识别号
        buyerRegisterAddress: '', // 买方注册地址
        partnerInvoiceId: null, // 主体id [编辑时不为空]
        partnerOrgId: '', // 所属公司
        buyerEmail: ''
      },

      editOff: false,

    };
  },
  mounted() {
    this.initDialog();
  },

  computed: {
    rules() {
      return {
        partnerOrgId: {
          required: true,
          message: this.$t('fms_body_recipientItem_dialog.qxzssgs')
        },
        buyerNumber: {
          required: true,
          message: this.$t('fms_body_recipientItem_dialog.qtxnsdjh')
        },
        buyerName: {
          required: true,
          message: this.$t('fms_body_recipientItem_dialog.qtxqymc')
        },
        buyerMobile: [{
          required: true,
          message: this.$t('fms_body_recipientItem_dialog.qtxdhhm')
        },
        {
          validator: null,
          message: this.$t('fms_body_recipientItem_dialog.qsrzqddhhm'),
        }],

        buyerDepositNumber: {
          required: true,
          message: this.$t('fms_body_recipientItem_dialog.qtxyhzh')
        },

        buyerDepositBank: {
          required: true,
          message: this.$t('fms_body_recipientItem_dialog.qtxzhmc')
        },
        buyerRegisterAddress: {
          required: true,
          message: this.$t('fms_body_recipientItem_dialog.qtxyydz')
        },
        buyerEmail: [
          {
            type: 'email',
            message: this.$t('fms_body_recipientItem_dialog.yxgsbzq') // 邮箱格式不正确
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]) }
        ]
      };
    },
  },
  methods: {
    // 初始化
    initDialog: function () {
      if (this.model.type === 'add') {
        this.editOff = false;
      }
      if (this.model.type === 'edit') {
        this.$setFormatData(this.form, this.model.data);
        this.pushConfId = this.model.data.pushConfId;
        // 编辑 disabled
        this.editOff = true;
      }
      this.rules.buyerMobile[1].validator = this.$mobilePhoneValidator;
    },

    // 确认保存分组
    saveGroup: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }

        if (this.model.type === 'add') {
          this.saveAddItem();
        }
        if (this.model.type === 'edit') {
          this.saveEditItem();
        }
      });
    },
    // 保存新增分组
    saveAddItem: function () {
      this.$postJSON(apis.crmPartnerInvoiceAdd, this.form, true).then(() => {
        this.$message({
          message: this.$t('Common.com_add_success'),
          type: 'success'
        });
        this.$emit('success');
        this.visible = false;
      });
    },
    saveEditItem: function () {
      this.$postJSON(apis.crmPartnerInvoiceUpdate, this.form, true).then(() => {
        if (this.model.type === 'add') {
          this.$message({
            message: this.$t('Common.com_add_success'),
            type: 'success'
          });
        } else if (this.model.type === 'edit') {
          this.$message({
            message: this.$t('Common.com_edit_success'),
            type: 'success'
          });
        }
        this.$emit('success');
        this.visible = false;
      });
    }
  }
};
</script>

<style lang="scss">
</style>
